module.exports = __webpack_public_path__ + "static/media/discoverAnimation.2e4a8079.png";